// Single source of truth for the marketing CTA across the entire site.
export const CTA_PRIMARY = "Start Your Empire Free";
export const CTA_PRIMARY_SUB = "No Card Required";
export const CTA_PRIMARY_FULL = "START YOUR EMPIRE FREE — No Card Required";

/**
 * Routes the primary CTA: if not logged in → Google sign-in, else → dashboard.
 * Pricing-card CTAs override with Stripe upgrade when the user is mid-trial.
 */
export const handleStartEmpireFree = (user, navigate) => {
  if (user) {
    navigate?.("/dashboard");
    return;
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
